module.exports = __webpack_public_path__ + "img/correct.8c52323d.svg";